<template>
  <div>
    <b-form-group v-slot="{ ariaDescribedby }">
      <b-form-radio-group
        id="radio-group-1"
        v-model="selected"
        :options="paymentTypeOptions"
        :aria-describedby="ariaDescribedby"
        name="radio-options"
      ></b-form-radio-group>
    </b-form-group>
  </div>
</template>

<script>
export default {
  props: { paymentType: null },
  watch: {
    selected: function(newValue) {
      this.selected = newValue;
      this.$emit("onPaymentTypeChange", newValue);
    },
  },
  data() {
    return {
      selected: null,
      paymentTypeOptions: [
        { value: "PREPAYMENT", text: "Non-allocated" },
        { value: "PROCEDUREPAYMENT", text: "Allocated to Procedures" },
      ],
    };
  },
  created() {
    this.selected = this.paymentType;
  },
};
</script>

<style></style>
